import { AccordionDetails } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Accordion, { AccordionSummary } from "@rui/Accordion";
import IconButton from "@rui/IconButton";

export const EditButton = styled(IconButton)(({ theme }) => ({
  width: "24px",
  height: "24px",
  padding: 0,
  color: theme.palette.shades.neutral[400],
  "& svg": {
    width: "14px",
    height: "14px",
  },
}));

export const TranscriptMetadataAccordion = styled(Accordion)({
  backgroundColor: "transparent",
});

export const TranscriptMetadataAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => ({
    minHeight: "26px",
    padding: theme.spacing(0),
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    [theme.breakpoints.up("mobile")]: {
      "& .MuiAccordionSummary-expandIconWrapper": {
        display: "none",
      },
    },
  })
);

export const TranscriptMetadataAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => ({
    padding: theme.spacing(0.5, 0, 0),
  })
);
